import { createBrowserRouter, Navigate } from "react-router-dom";
import { useState } from "react";
import App from "./App";
import Layout from "./components/layout/Menu";
import Login from "./page/Login";
import Register from "./page/Register";
import LoaderPage from "./page/loaderPage";
import Password from "./page/Mail";
import PasswordReset from "./page/Passwoard";
import VerificationCode from "./page/verificationCode";
import MyBalance from "./page/MyBalance";
import RegionPage from "./page/RegionPage";
import TarificationPage from "./page/TarificationPage";
import ConditionGeneralDeVente from "./page/ConditionGeneralDeVente";
import MentionLegales from "./page/MentionLegales";
import FreeLogin from "./page/FreeLogin";
import { CertificateCheck } from "./page/shared/CertificateCheck";
import AdminSoldePage from "./components/Gestionsolde";
import Unsubscribe from "./page/shared/Unsubscribe";
import CompleteRegistration from "./page/CompleteRegistration";
import VerifyEmail from "./page/VerifyEmail";
import VerifyCode from "./page/VerifyCode";
import AnonymousLogin from "./page/AnonymousLogin";
import LoadDraft from "./page/client/draft/LoadDraft";
import PublicAnnouncementCreation from "./page/public/PublicAnnouncementCreation";
import AnonymousModalPaiement from "./page/client/AnonymousModalPaiement";
import type { UserModel } from "../src/models/UserModel";
import SecretaryLogin from "./page/secretary/SecretaryLogin";
import SecretaryDashboard from "./page/secretary/SecretaryDashboard";
import KlarnaReturn from "./page/client/KlarnaReturn";
import Annuaire from "./page/client/Annuaire";
import ProfessionSettings from "./page/admin/ProfessionSettings";
import GestionDeMonCompte from "./page/client/gestion_de_mon_compte/GestionDeMonCompte";
import MenuClicksDashboard from "./components/MenuClickDashboard";
import ExternalAnnonceEntry from "./page/client/ExternalAnnonceEntry";
import ExternalAnnonceSlugEntry from "./page/client/ExternalAnnonceSlugEntry";
import NouvelleAnnonce from "./page/client/NouvelleAnnonce";
import EmailTemplatesManager from "./components/emailTemplate/EmailTemplatesManager";

function ModalAnonymousPage() {
  const [userDetails, setUserDetails] = useState<UserModel | null>(null);
  const [isModalVisible, setIsModalVisible] = useState(true);

  const handleModalClose = () => setIsModalVisible(false);

  return (
    <AnonymousModalPaiement
      isModalVisible={isModalVisible}
      handleModalClose={handleModalClose}
      userDetails={userDetails}
      setUserDetails={setUserDetails}
      isDraft={false}
    />
  );
}


const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "/",
        element: window.location.pathname.includes("certificate-checking") ? (
          <Navigate to="/certificate-checking/:numAnnonce" />
        ) : localStorage.getItem("userId") ? (
          <Navigate to="/home" />
        ) : (
          <Navigate to="/login" />
        ),
      },
      {
        path: "/login",
        element: <Login />,
      },
      {
        path: "/certificate-checking/:numAnnonce",
        element: <CertificateCheck />,
      },
      {
        path: "/client/annoucement-creation",
        element: <PublicAnnouncementCreation />,
      },
      {
        path: "/unsubscribe",
        element: <Unsubscribe />,
      },
      {
        path: "/free-login",
        element: <FreeLogin />,
      },
      {
        path: "/modal-anonymous",
        element: <ModalAnonymousPage />,
      },
      {
        path: "/anonymous-login",
        element: <AnonymousLogin />,
      },
      {
        path: "load-draft/:draftId",
        element: <LoadDraft />,
      },
      {
        path: "/klarna-return",
        element: <KlarnaReturn />,
      },
      {
        path: "/ext/annonce",
        element: <ExternalAnnonceEntry />,
      },
      {
        path: "/:mode/:typeAnnonce",
        element: <ExternalAnnonceSlugEntry />,
      },
      {
        path: "/home",
        element: <Layout />,
        children: [
          {
            path: "nouvelle-annonce",
            element: <NouvelleAnnonce />,
          },
          {
            path: "gestion-annonces",
            element: <h1>Gestion de mes annonces</h1>,
          },
          {
            path: "gestion-compte",
            element: <GestionDeMonCompte />,
          },
          {
            path: "gestion-clients",
            element: <h1>Gestion de parrainage</h1>,
          },
          {
            path: "gestion-emails",
            element: <h1>Gestion des emails</h1>,
          },
          {
            path: "gestion-logos",
            element: <h1>Gestion des logos</h1>,
          },
          {
            path: "gestion-factures",
            element: <h1>Gestion de mes factures</h1>,
          },
          {
            path: "equipe",
            element: <h1>Gestion des équipe</h1>,
          },
          {
            path: "draft",
            element: <h1>Mes brouillons</h1>,
          },
          {
            path: "info-kbis",
            element: <h1>Informations KBIS</h1>,
          },
          {
            path: "mon-solde",
            element: <MyBalance />,
          },
          {
            path: "admin/users",
            element: <h1>Liste des utilisateurs</h1>,
          },
          {
            path: "admin/validation-request",
            element: <h1>Demande de validation</h1>,
          },
          {
            path: "admin/annonces",
            element: <h1>Liste des annonces</h1>,
          },
          {
            path: "admin/parrainage",
            element: <h1>Gestion de parrainage</h1>,
          },
          {
            path: "admin/emails",
            element: <h1>Gestion email</h1>,
          },
          {
            path: "admin/factures",
            element: <h1>Gestion factures</h1>,
          },
          {
            path: "admin/demande-validation",
            element: <h1>Demande de validation</h1>,
          },
          {
            path: "admin/types-annonces",
            element: <h1>Liste des types d'annonces</h1>,
          },
          {
            path: "admin/codes-postals",
            element: <h1>Liste des codes postaux</h1>,
          },
          {
            path: "admin/gestion-codes-promo",
            element: <h1>Gestion des codes promo</h1>,
          },
          {
            path: "admin/prix-type-annonce",
            element: <h1>Prix type d’annonce</h1>,
          },
          {
            path: "admin/solde",
            element: <AdminSoldePage />,
          },
          {
            path: "admin/gestion-compte",
            element: <h1>Gestion de compte administrateur</h1>,
          },
          {
            path: "admin/tarifs-legalin",
            element: <h1>Tarifs Legalin</h1>,
          },
          {
            path: "annuaire",
            element: <Annuaire />,
          },
          {
            path: "admin/parametres",
            element: <ProfessionSettings />
          },
          {
            path: "admin/dashboard",
            element: "MenuDashboard"
          },
          { path:"admin/email-template",
            element:<EmailTemplatesManager/>
          }
        ],
      },
      {
        path: "/register",
        element: <Register />,
      },
      {
        path: "/mail",
        element: <Password />,
      },
      {
        path: "/code",
        element: <VerificationCode />,
      },
      {
        path: "/password",
        element: <PasswordReset />,
      },
      {
        path: "/region",
        element: <RegionPage />,
      },
      {
        path: "/tarification",
        element: <TarificationPage />,
      },
      {
        path: "/conditiondevente",
        element: <ConditionGeneralDeVente />,
      },
      {
        path: "/mentionlegale",
        element: <MentionLegales />,
      },
      {
        path: "/complete-registration",
        element: <CompleteRegistration />,
      },
      {
        path: "/verify-email",
        element: <VerifyEmail />,
      },
      {
        path: "/verify-code",
        element: <VerifyCode />,
      },
      {
        path: "*",
        element: <LoaderPage />,
      },
      {
        path: "/secretary-login",
        element: <SecretaryLogin />,
      },
      {
        path: "/secretary-dashboard",
        element: <SecretaryDashboard />,
      }
    ],
  },
]);

export default router;
